import React, { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import { PetInterface } from '../../types/pet';
import './banner.scss';

const Banner = ({ petProfile }: { petProfile: PetInterface }) => {
  const bannerRef = useRef<HTMLDivElement>(null);
  const [imageState, setImageState] = useState({ height: 0, imgSrc: '', isImageBanner: false });
  const [isLoaded, setIsLoaded] = useState(false);

  const setValues = ({
    isImageBanner = false,
    url = '',
  }: {
    isImageBanner?: boolean;
    url?: string;
  }) => {
    const mediumBreakpoint = 640;
    const largeBreakpoint = 980;
    const hugeBreakpoint = 1200;
    const giantBreakpoint = 1400;
    const maxHeaderWidth = 1392;

    let bannerWidth = 0;
    let bannerHeight = 0;
    if (bannerRef.current || isImageBanner) {
      // checking if it exists to keep types clean vs a number | undefined
      if (bannerRef.current?.clientWidth) {
        bannerWidth = bannerRef.current.clientWidth;
      }
    } else {
      const windowWidth = window.innerWidth;
      if (windowWidth >= maxHeaderWidth + 60) {
        bannerWidth = maxHeaderWidth;
      } else if (windowWidth >= giantBreakpoint) {
        bannerWidth = windowWidth - 120;
      } else if (windowWidth >= largeBreakpoint) {
        bannerWidth = windowWidth - 60;
      } else {
        bannerWidth = windowWidth;
      }
    }

    if (bannerWidth < mediumBreakpoint) {
      bannerHeight = (bannerWidth * 7) / 16;
    } else if (bannerWidth < hugeBreakpoint) {
      bannerHeight = (bannerWidth * 5) / 16;
    } else {
      bannerHeight = (bannerWidth * 4) / 16;
    }

    if (isImageBanner && bannerRef.current && url) {
      bannerRef.current.style.backgroundImage = `url('${url}')`;
    }
    setImageState({ height: bannerHeight, imgSrc: url, isImageBanner });
    setIsLoaded(true);
  };

  useEffect(() => {
    if (petProfile.photoUrl) {
      let url = petProfile.photoUrl.replace(/_SS150_/, '_QL100_');
      const img = new Image();
      img.src = url;
      img.addEventListener('load', () => {
        const isImageBanner = img.width > img.height * 2;
        setValues({ isImageBanner, url });
      });
      img.addEventListener('error', () => {
        const isImageBanner = img.width > img.height * 2;
        setValues({ isImageBanner, url });
      });
    } else {
      setValues({});
    }
  }, [petProfile.photoUrl]);

  const { height, imgSrc, isImageBanner } = imageState;

  const bannerClasses = classnames('profile-banner', {
    'profile-banner--special': isImageBanner && isLoaded,
    'profile-banner--standard': !isImageBanner && !!imgSrc && isLoaded,
    'profile-banner--no-image': !imgSrc && isLoaded,
  });

  return (
    <div ref={bannerRef} className={bannerClasses} style={{ height: `${height}px` }}>
      {!!imgSrc && !isImageBanner && isLoaded && (
        <figure className="profile-banner__figure">
          <img className="profile-banner__image" src={imgSrc} alt={petProfile.name} />
        </figure>
      )}
    </div>
  );
};

export default Banner;
